// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39AEA","title":"Header_title__3yUP2","left":"Header_left__2NtYD","clinicName":"Header_clinicName__2egis"};